const ReadMore = (() => {
  let s;

  return {

    settings() {
      return {
        content: document.querySelectorAll('.js-read-more'),
        originalContentArr: [],
        truncatedContentArr: [],
        moreLink: "Read More",
        lessLink: "Less Link",
      }
    },

    init() {
      s = this.settings();
      this.bindEvents();
    },

    bindEvents() {
      ReadMore.truncateText();
    },

    countWords(str) {
      return str.split(/\s+/).length;
    },

    ellipseContent(str, wordsNum) {
      return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
    },

    truncateText() {

      for (let i = 0; i < s.content.length; i++) {
        const originalContent = s.content[i].innerHTML;
        const numberOfWords = s.content[i].dataset.rmWords;
        const truncateContent = ReadMore.ellipseContent(originalContent, numberOfWords);
        const originalContentWords = ReadMore.countWords(originalContent);

        s.originalContentArr.push(originalContent);
        s.truncatedContentArr.push(truncateContent);

        if (numberOfWords < originalContentWords) {
          // Wrap truncated content with a span containing the 'read-more__link' class
          s.content[i].innerHTML = `<span class="read-more__link-wrap">${s.truncatedContentArr[i]}</span>`;
          let self = i;
          ReadMore.createLink(self);
        }
      }
      ReadMore.handleClick(s.content);
    },

    createLink(index) {
      const linkWrap = document.createElement('span');
      linkWrap.className = 'read-more__link-wrap';
      linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;
      s.content[index].appendChild(linkWrap);
    },

    handleClick(el) {
      const readMoreLink = document.querySelectorAll('.read-more__link');

      for (let j = 0, l = readMoreLink.length; j < l; j++) {

        readMoreLink[j].addEventListener('click', function() {
          const moreLinkID = this.getAttribute('id');
          let index = moreLinkID.split('_')[1];

          el[index].classList.toggle('is-expanded');

          const linkWrap = el[index].querySelector('.read-more__link-wrap');

          if (this.dataset.clicked !== 'true') {
             linkWrap.innerHTML = s.originalContentArr[index];
             this.innerHTML = s.lessLink;
             this.dataset.clicked = true;
          } else {
            linkWrap.innerHTML = s.truncatedContentArr[index];
            this.innerHTML = s.moreLink;
            this.dataset.clicked = false;
          }
        });
      }
    },

    openAll() {
      const instances = document.querySelectorAll('.read-more__link');
      for (let i = 0; i < instances.length; i++) {
        content[i].innerHTML = s.truncatedContentArr[i];
        instances[i].innerHTML = s.moreLink;
      }
    }
  }
})();
